
export default {
  // Reviews
  "edit_review": "编辑评论",
  "review": "评论",
  "film_friendly_score": "胶片友好度评分",
  "hand_check": "手动检查",
  "successful": "成功",
  "unsuccessful": "不成功",
  "delete_review": "删除评论",
  "review_by": "评论者",
};
